// extracted by mini-css-extract-plugin
export default {"footerBg":"Q-z","footerTopLinks":"R-z","footerFeedback":"S-z","footerSocial":"T-z","footerLegalLinks":"U-z","footerIconCards":"V-z","footerBotCopy":"W-z"};